import { type IInfiniteSearchResult } from 'shared/api/offers';
import { type IOffer } from 'shared/offer';

export function addRecommendationsModelVersion(offers: IOffer[], recommendations: IInfiniteSearchResult[]): IOffer[] {
  const recommendationsByOfferId = new Map(
    recommendations.map(recommendation => [recommendation.itemId, recommendation]),
  );

  return offers.map(offer => ({
    ...offer,
    modelVersion: recommendationsByOfferId.get(offer.id)?.modelVersion ?? offer.modelVersion,
  }));
}
